import Hash from 'object-hash';
import { IClientCacheItem, IClientCacheManager } from './entities';

window.__clientCache = new Map();

const ClientCacheManager: IClientCacheManager = {
	createHash: (url, payload) =>
		Hash({
			url,
			payload
		}),
	getCache: (relationId, hash) => {
		const relatedCacheData = window.__clientCache.get(relationId);
		return relatedCacheData?.get(hash);
	},
	setCache: args => {
		const { url, payload, relationId } = args;

		const hash = ClientCacheManager.createHash(url, payload);
		const cache: IClientCacheItem<any, any> = {
			url,
			payload,
			result: args.result,
			relationId
		};

		if (window.__clientCache.has(relationId)) {
			window.__clientCache.get(relationId).set(hash, cache);
		} else {
			window.__clientCache.set(
				relationId,
				new Map<string, IClientCacheItem<any, any>>().set(hash, cache)
			);
		}
	},
	cleanCache: relationId => window.__clientCache.delete(relationId)
};

export { ClientCacheManager };
